import { routeHead } from "@/lib/routeHead";
import { META_DESCRIPTIONS } from "@/lib/metaDescriptions";
import { createFileRoute } from "@tanstack/react-router";
import MarketingSalesHub from "@/pages/MarketingSalesHub";

export const Route = createFileRoute("/pl/marketing-sales")({
  head: () => routeHead('Marketing i sprzedaż — Produkty AGAPE', META_DESCRIPTIONS.marketing.pl, '/pl/marketing-sales'),
  component: MarketingSalesHub,
});
